import React from 'react'
import CartItem from './CartItem/CartItem'
import { Link } from "react-router-dom"
import headerImg from "../../assets/basket-header.png";
import { useEffect } from 'react';
import { CoinBase } from '../../lib/CoinBase';
import { useState } from 'react';
import { GIFTSWAP_BENEFIT } from '../../Env';

const Cart = ({ cart, handleUpdateCartQty, handleRemoveFromCart }) => {

  const [hideCurrency, setHideCurrency] = useState(true);
  const [state, setState] = useState({
    currency : localStorage.getItem('currency') || "USDT",
    rate : null, 
    total : null
  })

  useEffect(() => {
    if(!cart || cart.length == 0) return;
    const totalEuro = cart.reduce((sum, x) => sum+x.euroPrice*x.quantity*GIFTSWAP_BENEFIT, 0);
    CoinBase.GetRate(state.currency, "EUR")
      .then((rate) => {
        setState({
          ...state,
          total : totalEuro / rate,
          rate
        })
      })
      .catch(console.log);

  }, [cart, state.currency])

  const selectCurrency = ({ target }) => {
    localStorage.setItem('currency', target.value)
    setState({ ...state, currency : target.value })
  }
 
  const EmptyCart = () => (
    <div className="py-5 text-center">
      <h6>You Have 0 items in your Basket! </h6>
      <button className="btn-yellow mt-5" ><Link to="/products" >Add Items</Link></button>
    </div>
  )

  const FilledCart = () => (
    <>
      <table className="items w-100">
        <thead>
          <tr>
            <td colSpan="2"> </td>
            <td>Quantity</td>
            <td>Price</td>
            <td>Total</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          {cart.map((item) => (
            <CartItem currency={state.currency} item={item} rate={state.rate} onUpdateCartQty={handleUpdateCartQty} onRemoveFromCart={handleRemoveFromCart} />
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="4"></td>
            <td colSpan={2}>
              <div className='d-flex justify-content-between'>
                <h4>Total</h4>
                {state.total != null && <h4>{state.total.toFixed(4)} {state.currency}</h4>}
              </div>
            </td>
          </tr>
          <tr className="currency-button-row">
            <td colSpan={4}></td>
            <td colSpan={2} style={{ textAlign : "right" }}>
              <button className="btn-yellow" onClick={() => setHideCurrency(!hideCurrency)}>Change currency</button>
            </td>

          </tr>
          {/* <tr>
            <td colSpan="4"></td>
            <td colSpan="2">Do you have a promotional code?</td>
          </tr>
          <tr>
            <td colSpan="4"></td>
            <td>
              <div className="form-group mb-0">
                <input
                  type="text"
                  className="form-control"
                  id="rcp-email"
                  placeholder="Promo Codes"
                />
              </div>
            </td>
          </tr> */}
          <tr>
            <td colSpan="4"></td>
            <td colSpan="2">
              <Link to="/checkout"><button className="btn-yellow w-100">Proceed to checkout</button></Link>
            </td>
          </tr>
        </tfoot>
      </table>
    </>
  )
  if (!cart) return 'loading...';

  return (
    <>
      <div className="page-head basket-page">
        <div className="col-lg-2 col-md-3 col-3">
          <div className="mybasket">
            <h3>Your basket</h3>
            <p>(  {cart.length}  items)</p>
            <button className="btn-yellow" ><Link to="/products">Add other gift cards</Link></button>
          </div>
        </div>
        <div className="col-lg-3 pt-lg-0 col-md-5 pt-md-3 pt-5 col-5">
          <img src={headerImg} alt={headerImg} />
        </div>
      </div>
      <div className="current-basket">
        <div className="container py-5">
          {!cart.length ? <EmptyCart /> : <FilledCart />}
        </div>
      </div>
      {!hideCurrency && <div style={{ height : 81 }}></div>}
      <div className={"currency-popup" + (hideCurrency ? '' : ' active')}>
        <div>
          <span className="h4">Choose your currency</span>
          <select className='select select-lg' onChange={selectCurrency}>
            <option value={"USDT"} selected={state.currency == 'USDT'}>USDT</option>
            <option value={"USDC"} selected={state.currency == 'USDC'}>USDC</option>
            <option value={"DAI"} selected={state.currency == 'DAI'}>DAI</option>
            <option value={"BNB"} selected={state.currency == 'BNB'}>BNB</option>
            <option value={"BUSD"} selected={state.currency == 'BUSD'}>BUSD</option>
          </select>
        </div>
      </div>
    </>
  )
}

export default Cart
